import React from 'react';

export const IframeComponent = ({ src, title }) => (
  <iframe
    src={src}
    className="w-100 h-100 border-0"
    title={title}
  ></iframe>
);